import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Container,
  Divider,
  Stack,
} from '@mui/material';
import {
  EventAvailable,
  Group,
  VerifiedUser,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface Benefit {
  title: string;
  description: string;
  icon: React.ReactElement;
}

const PromotionBooking: React.FC = () => {
  const navigate = useNavigate();
  // Das typische Kumao-Grün aus deinem Logo
  const kumaoGreen = '#8cb021';

  const benefits: Benefit[] = [
    {
      title: 'Einfache Online-Buchung',
      description: 'Kumao.at ist deine digitale Plattform für lokale Dienstleistungen. Buche Termine bei Handwerkern, Ärzten und mehr ganz einfach online – ohne Anrufe oder Wartezeiten.',
      icon: <EventAvailable
        sx={{ color: kumaoGreen }}
        fontSize="large"
      />
    },
    {
      title: 'Professionelle Online-Präsenz',
      description: 'Dienstleister auf Kumao.at haben eine professionelle Online-Präsenz mit detaillierten Profilen und modernem Buchungstools.',
      icon: <VerifiedUser
        sx={{ color: kumaoGreen }}
        fontSize="large"
      />
    },
    {
      title: 'Sicher und transparent',
      description: 'Kumao steht für transparente Preise und Inhalte. Keine versteckten Kosten – vertraue auf eine zuverlässige Plattform, die Updates und Support inklusive bietet.',
      icon: <Group
        sx={{ color: kumaoGreen }}
        fontSize="large"
      />
    }
  ];

  return (
    <Container
      maxWidth="lg"
      sx={{ mt: 5, mb: 6 }}
    >
      {/* Trenner zur Buchungsbestätigung oben */}
      <Divider sx={{ mb: 6 }}>
        <Typography
          variant="overline"
          sx={{ px: 2, color: 'text.secondary', fontWeight: 'bold', letterSpacing: 1.5 }}
        >
          Was ist Kumao?
        </Typography>
      </Divider>

      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ fontWeight: 800, color: '#333' }}
        >
          Dein Termin ist erst der Anfang.
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: '600px', mx: 'auto' }}
        >
          Kumao ist die Plattform für lokale Services. Wir bringen Angebot und Nachfrage zusammen – unkompliziert und digital.
        </Typography>
      </Box>

      <Grid
        container
        spacing={4}
      >
        {benefits.map((benefit, index) => (
          <Grid
            item
            xs={12}
            md={4}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          >
            <Card
              onClick={() => navigate('/')}
              elevation={0}
              sx={{
                height: '100%',
                backgroundColor: '#fbfbfb',
                borderRadius: 4,
                border: '1px solid #eee',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 12px 24px rgba(0,0,0,0.05)'
                }
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Stack
                  spacing={2}
                  alignItems="center"
                  textAlign="center"
                >
                  <Box sx={{
                    p: 2,
                    borderRadius: '50%',
                    bgcolor: 'rgba(140, 176, 33, 0.1)',
                    display: 'flex'
                  }}
                  >
                    {benefit.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{ fontWeight: 700 }}
                  >
                    {benefit.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ lineHeight: 1.6 }}
                  >
                    {benefit.description}
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default PromotionBooking;
